(function () {
  if (window.nutriadnAnnouncementInitialized) return;
  window.nutriadnAnnouncementInitialized = true;

  const initialize = (root = document) => {
    root.querySelectorAll('.announcement-bar__slide').forEach((bar) => {
      const element = bar.querySelector('.swiper');
      if (!element || element.swiper || typeof Swiper === 'undefined') return;
      const multiple = element.querySelectorAll('.swiper-slide').length > 1;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = multiple && bar.dataset.autoplay === 'true' && !reducedMotion;
      new Swiper(element, {
        slidesPerView: 1,
        rewind: multiple,
        watchOverflow: true,
        autoHeight: true,
        speed: reducedMotion ? 0 : 300,
        autoplay: autoplay ? {
          delay: Number(bar.dataset.delay) || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: bar.dataset.pauseOnHover === 'true',
        } : false,
        navigation: {
          nextEl: bar.querySelector('.announcement-btn-next'),
          prevEl: bar.querySelector('.announcement-btn-prev'),
        },
      });
      bar.addEventListener('focusin', () => element.swiper?.autoplay?.stop());
      bar.addEventListener('focusout', (event) => {
        if (autoplay && !bar.contains(event.relatedTarget) && !bar.dataset.editingBlock) {
          element.swiper?.autoplay?.start();
        }
      });
    });
  };

  initialize();
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.announcement-bar__slide .swiper').forEach((element) => {
      element.swiper?.destroy(true, true);
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('.announcement-bar__message');
    const bar = slide?.closest('.announcement-bar__slide');
    const element = bar?.querySelector('.swiper');
    if (!element?.swiper) return;
    bar.dataset.editingBlock = 'true';
    element.swiper.autoplay?.stop();
    element.swiper.slideTo(Array.from(element.querySelectorAll('.swiper-slide')).indexOf(slide));
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const bar = event.target.closest('.announcement-bar__slide');
    if (!bar) return;
    delete bar.dataset.editingBlock;
    if (bar.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      bar.querySelector('.swiper')?.swiper?.autoplay?.start();
    }
  });
})();
